export default __webpack_public_path__ + "static/media/discover_front.9d015fae.png";